class SelectableSearchableSortableListCtrl {
  constructor(filterFilter, $parse, searchProp = null, registerInvalidate = null) {
    Object.assign(this, { filterFilter, $parse });

    this.isAllSelected = false;
    this.selectedItemIds = Object.create(null);
    this._searchProp = searchProp;
    this._invalidate();

    if (registerInvalidate) {
      registerInvalidate(() => this._invalidate());
    }
  }

  get items() {
    return this._items;
  }

  set items(value) {
    this._invalidate();
    this._items = value;
  }

  get search() {
    return this._search;
  }

  set search(value) {
    this._invalidate();
    this._search = value;
  }

  get visibleItems() {
    if (!this._visibleItems) {
      const filterArg = this._searchProp ? { [this._searchProp]: this.search } : this.search;
      this._visibleItems = this.items ? this.filterFilter(this.items, filterArg) : [];
    }

    return this._visibleItems;
  }

  get visibleItemsDict() {
    if (!this._visibleItemsDict) {
      this._visibleItemsDict = this.visibleItems.reduce(
        (dict, item) => ({ ...dict, [item.id]: item }),
        Object.create(null)
      );
    }

    return this._visibleItemsDict;
  }

  set visibleItemsDict(val) { // eslint-disable-line
    // no-op that needs to exist in order to set up a two way binding
  }

  get selectedVisibleItemsCount() {
    const { visibleItemsDict } = this;
    return Object.keys(this.selectedItemIds).filter(
      (id) => this.selectedItemIds[id] && id in visibleItemsDict
    ).length;
  }

  get isSomethingSelected() {
    return this.selectedVisibleItemsCount > 0;
  }

  set isSomethingSelected(val) { // eslint-disable-line
    // no-op that needs to exist in order to set up a two way binding
  }

  get isAllSelected() {
    return (
      this.selectedVisibleItemsCount > 0 &&
      this.selectedVisibleItemsCount === this.visibleItems.length
    );
  }

  set isAllSelected(value) {
    this.selectedItemIds = Object.create(null);

    if (value) {
      this.selectedItemIds = this.visibleItems.reduce(
        (reduced, item) => ({ ...reduced, [item.id]: true }),
        this.selectedItemIds
      );
    }
  }

  orderBy(prop) {
    return [this.groupFalsy(prop), prop];
  }

  sortBy(sortMethod, prop) {
    this[prop] = this[prop] === sortMethod ? `-${sortMethod}` : sortMethod;
  }

  isSortedBy(sortMethod, prop) {
    return this[prop] && this[prop].endsWith(sortMethod);
  }

  groupFalsy(_prop = '') {
    let rev = 1;
    let prop = _prop;
    if (prop[0] === '-') {
      prop = prop.substr(1);
      rev = -1;
    }

    const getValue = this.$parse(prop);

    return (obj) => rev * (getValue(obj) ? 1 : -1);
  }

  _invalidate() {
    this._visibleItems = null;
    this._visibleItemsDict = null;
  }
}

export default SelectableSearchableSortableListCtrl;
